import * as Eq from "fp-ts/es6/Eq"
import * as Str from "fp-ts/es6/string"

export enum VideoSource {
  youtube = "youtube",
  vimeo = "vimeo",
}

export const videoSource = Str.Eq as any
